/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Kind of subscriber a product is meant for. Only meaningful on branches whose capabilities
 * declare hasTargetedSubscriber; any other branch keeps "any".
 * 
 * @export
 */
export const TargetedSubscriberEnum = {
    Any: 'any',
    LegalEntity: 'legalEntity',
    Individual: 'individual'
} as const;
export type TargetedSubscriberEnum = typeof TargetedSubscriberEnum[keyof typeof TargetedSubscriberEnum];


export function instanceOfTargetedSubscriberEnum(value: any): boolean {
    for (const key in TargetedSubscriberEnum) {
        if (Object.prototype.hasOwnProperty.call(TargetedSubscriberEnum, key)) {
            if (TargetedSubscriberEnum[key as keyof typeof TargetedSubscriberEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TargetedSubscriberEnumFromJSON(json: any): TargetedSubscriberEnum {
    return TargetedSubscriberEnumFromJSONTyped(json, false);
}

export function TargetedSubscriberEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetedSubscriberEnum {
    return json as TargetedSubscriberEnum;
}

export function TargetedSubscriberEnumToJSON(value?: TargetedSubscriberEnum | null): any {
    return value as any;
}

export function TargetedSubscriberEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): TargetedSubscriberEnum {
    return value as TargetedSubscriberEnum;
}

